import React from 'react';
import { ContentSection } from '@/constants/tos';
import Nav from './Nav';
import Content from './Content';

interface Props {
  data: {
    title: string;
    date: string;
    sections: ContentSection[];
  };
  sections: ContentSection[];
  page?: string;
}

export default function Mobile({ data, sections, page }: Props) {
  return (
    <div className="block md:hidden">
      <Nav page={page} />
      <Content data={data} sections={sections} />
    </div>
  );
}
